import styled from 'styled-components';
import { spaceMixin, token } from '@zillow/constellation';

const GLEAM_CIRCLE_SIZE = '8px';

export const StyledVerticalNavigation = styled.div`
  display: flex;
  flex-direction: column;

  padding: ${spaceMixin('xs')};
  width: 100%;
  height: 100%;
`;

export const StyledLogoContainer = styled.div`
  padding: ${spaceMixin('lg')} 0 ${spaceMixin('lg')} ${spaceMixin('xs')};
`;

export const StyledNavigationListContainer = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  margin-bottom: ${spaceMixin('sm')};
  overflow-y: auto;
`;

export const StyledAccountContainer = styled.div`
  /* pushes the div to the bottom */
  margin-top: auto;
`;

export const StyledMessageGleamContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  /* align with + icon */
  margin-right: 4px;
`;

export const StyledMessageCount = styled.div<{ marginRight?: number }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  margin-right: ${({ marginRight = 0 }) => `${marginRight}px`};

  padding: 0 12px;

  height: 22px;

  font-weight: bold;
  color: white;
  text-decoration: underline;
  text-decoration-color: ${token('colors.orange400')};
  text-align: center;

  background-color: ${token('colors.orange400')};
  border-radius: 11px;

  &:hover {
    color: ${token('colors.white')};
  }
`;

export const StyledNotificationCircle = styled.div`
  width: ${GLEAM_CIRCLE_SIZE};
  height: ${GLEAM_CIRCLE_SIZE};
  border-radius: ${token('radii.ellipse')};
  background: ${token('colors.orange400')};
`;

export const StyledLogoZRMStacked = styled.div`
  width: 154px;
  height: auto;
`;
